import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    principalRentOrOwn,
    principalIsPG,
    principalMortgagePayment,
    applicantSameAsPrincipal,
  },
} = loanFormModel;

export class PrincipalMortgagePaymentValidation implements ValidationSchema {
  public name = principalMortgagePayment.name;
  public label = principalMortgagePayment.label;
  public dependsOn: string[] = [
    principalIsPG.name,
    principalRentOrOwn.name,
    applicantSameAsPrincipal.name,
  ];
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    principalIsPG: string,
    principalRentOrOwn: string,
    applicantSameAsPrincipal: string,
    schema
  ) {
    if (
      principalIsPG === 'Yes' &&
      applicantSameAsPrincipal === 'Yes' &&
      principalRentOrOwn === 'Own'
    ) {
      return schema.required(principalMortgagePayment.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new PrincipalMortgagePaymentValidation());
